import { useEffect } from "react";
import { Route, Routes } from "react-router";
import { Layout } from "./components/Layout.tsx";
import { LocaleProvider } from "./lib/i18n.tsx";
import { MeProvider } from "./lib/me.tsx";
import { applyTheme, getThemePref } from "./lib/theme.ts";
import {
  AdminInvites,
  AdminListingDetail,
  AdminListings,
  AdminPurchaseDetail,
  AdminPurchases,
  AdminQueues,
  AdminShell,
  AdminTaxonomy,
  AdminUserDetail,
  AdminUsers,
} from "./routes/admin/Admin.tsx";
import { AdminMetrics } from "./routes/admin/Metrics.tsx";
import { Browse } from "./routes/Browse.tsx";
import { DevUi } from "./routes/DevUi.tsx";
import { Home } from "./routes/Home.tsx";
import { InviteLanding } from "./routes/InviteLanding.tsx";
import { InviteAsk, InviteRequests } from "./routes/InviteRequests.tsx";
import { Legal } from "./routes/Legal.tsx";
import { Listing } from "./routes/Listing.tsx";
import { ListingOwner } from "./routes/ListingOwner.tsx";
import { Login } from "./routes/Login.tsx";
import { MePage } from "./routes/MePage.tsx";
import { MyListings } from "./routes/MyListings.tsx";
import { NotFound } from "./routes/NotFound.tsx";
import { Notifications } from "./routes/Notifications.tsx";
import { ProblemPage } from "./routes/Problem.tsx";
import { Profile } from "./routes/Profile.tsx";
import { Purchase } from "./routes/Purchase.tsx";
import { PurchaseList } from "./routes/PurchaseList.tsx";
import { Sell } from "./routes/Sell.tsx";
import { Settings } from "./routes/Settings.tsx";
import { Watching } from "./routes/Watching.tsx";

export function App() {
  useEffect(() => applyTheme(getThemePref()), []);
  return (
    <LocaleProvider>
      <MeProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/s" element={<Browse />} />
            <Route path="/login" element={<Login />} />
            <Route path="/i/:code" element={<InviteLanding />} />
            <Route path="/l/:id" element={<Listing />} />
            <Route path="/legal/:doc" element={<Legal />} />
            <Route path="/me" element={<MePage />} />
            <Route path="/me/settings" element={<Settings />} />
            <Route path="/me/notifications" element={<Notifications />} />
            <Route path="/me/watching" element={<Watching />} />
            <Route path="/me/listings" element={<MyListings />} />
            <Route path="/me/listings/:id" element={<ListingOwner />} />
            <Route path="/sell" element={<Sell />} />
            <Route path="/sell/:id" element={<Sell />} />
            <Route path="/u/:handle" element={<Profile />} />
            <Route path="/p/:id" element={<Purchase />} />
            <Route path="/p/:id/problem" element={<ProblemPage />} />
            <Route path="/p/:id/invite" element={<InviteAsk />} />
            <Route path="/me/invite-requests" element={<InviteRequests />} />
            <Route path="/me/purchases" element={<PurchaseList kind="purchases" />} />
            <Route path="/me/sales" element={<PurchaseList kind="sales" />} />
            {import.meta.env.DEV ? <Route path="/dev/ui" element={<DevUi />} /> : null}
            <Route path="/admin" element={<AdminShell />}>
              <Route index element={<AdminQueues />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="users/:id" element={<AdminUserDetail />} />
              <Route path="listings" element={<AdminListings />} />
              <Route path="listings/:id" element={<AdminListingDetail />} />
              <Route path="purchases" element={<AdminPurchases />} />
              <Route path="purchases/:id" element={<AdminPurchaseDetail />} />
              <Route path="queues" element={<AdminQueues />} />
              <Route path="invites" element={<AdminInvites />} />
              <Route path="taxonomy" element={<AdminTaxonomy />} />
              <Route path="metrics" element={<AdminMetrics />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </MeProvider>
    </LocaleProvider>
  );
}
